import React, { useState, createContext } from "react";
import { invoiceStatuses } from "../Mappings";

export const InvoiceDataContext = createContext();

const InvoiceDataContextProvider = (props) => {
  const [invoiceData, setInvoiceData] = useState([]);

  const invoiceDataModel = {
    id: {
      displayName: "Invoice ID",
      displayValue: (value) => value,
    },
    netTotal: {
      displayName: "Total Amount",
      displayValue: (value) => `$${(Math.round(value * 100) / 100).toFixed(2)}`,
    },
    startDate: {
      displayName: "Start Date",
      displayValue: (value) => value.split("T")[0],
    },
    endDate: {
      displayName: "End Date",
      displayValue: (value) => value.split("T")[0],
    },
    truckId: {
      displayName: "Truck ID",
      displayValue: (value) => value,
    },
    approvalState: {
      displayName: "Approval State",
      displayValue: (value) => invoiceStatuses[value],
    },
    vendorTradingName: {
      displayName: "Trading Name",
      displayValue: (value) => value,
    },
  };

  const updateInvoice = (id, invoice) => {
    const idx = invoiceData.findIndex((invoice) => invoice.id === id);
    setInvoiceData([
      ...invoiceData.slice(0, idx),
      { ...invoiceData[idx], ...invoice },
      ...invoiceData.slice(idx + 1),
    ]);
  };

  return (
    <InvoiceDataContext.Provider
      value={{ 
        invoiceData, 
        setInvoiceData, 
        invoiceDataModel, 
        updateInvoice,
      }}
    >
      {props.children}
    </InvoiceDataContext.Provider>
  );
};

export default InvoiceDataContextProvider;
